package com.arena_web.core.viewmodel

import com.arena_web.di.AppContainer
import com.arena_web.domain.usecases.auth.OAuthLoginUseCase
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.flow.asStateFlow
import kotlinx.coroutines.flow.update
import kotlinx.coroutines.launch

data class LoginUiState(
    val isLoading: Boolean = false,
    val error: String? = null
)

class LoginViewModel(
    private val oauthLoginUseCase: OAuthLoginUseCase,
    private val container: AppContainer? = null
) : BaseViewModel() {

    private val _uiState = MutableStateFlow(LoginUiState())
    val uiState: StateFlow<LoginUiState> = _uiState.asStateFlow()

    @Suppress("LongParameterList")
    fun loginWithOAuth(
        provider: String,
        providerId: String,
        email: String,
        fullName: String? = null,
        avatarUrl: String? = null,
        dateOfBirth: String? = null,
        gender: String? = null,
        city: String? = null,
        country: String? = null,
        languages: List<String>? = null,
        onSuccess: () -> Unit
    ) {
        viewModelScope.launch {
            _uiState.update { it.copy(isLoading = true, error = null) }

            val result = oauthLoginUseCase(
                provider = provider,
                providerId = providerId,
                email = email,
                fullName = fullName,
                avatarUrl = avatarUrl,
                dateOfBirth = dateOfBirth,
                gender = gender,
                city = city,
                country = country,
                languages = languages,
            )

            result.onSuccess { response ->
                container?.createAuthenticatedClients(response.accessToken)
                _uiState.update { it.copy(isLoading = false) }
                onSuccess()
            }.onFailure { e ->
                _uiState.update {
                    it.copy(isLoading = false, error = e.message ?: "Login failed")
                }
            }
        }
    }

    fun clearError() {
        _uiState.update { it.copy(error = null) }
    }
}
